@use "~components/Navbar/tokens" as Navbar;
@use "~theme/breakpoints";

.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: Navbar.$nav-height-mobile;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @include breakpoints.desktop {
    height: Navbar.$nav-height-desktop;
  }
}

.container {
  max-width: var(--max-desktop-width);
  flex-grow: 1;
}
